import React, { useEffect, useState } from "react";
import { ethers } from "ethers";

import { contractABI, contractAddress } from "../utils/constants";
export const TransactionContext = React.createContext();

const { ethereum } = window;

const getEthereumContract = () => {
  const provider = new ethers.providers.Web3Provider(ethereum);
  const signer = provider.getSigner();
  const transactionsContract = new ethers.Contract(
    contractAddress,
    contractABI,
    signer
  );
    return transactionsContract;
};

export const TransactionProvider = ({ children }) => {
  const [currentAccount, setCurrentAccount] = useState("");
  const [formData, setFormData] = useState({addressTo:'',amount:'',keyword:'',message:''});
    const [isLoading, setIsLoading] = useState(false)
    const [transactionCount, setTransactionCount] = useState(localStorage.getItem('transactionCount'))
    const [transactions, setTransactions] = useState([]);

  const handleChanges=(e,name)=>{
    setFormData((prevState)=>({...prevState,[name]:e.target.value}));
  }

  const getAllTransactions=async ()=>{
      try {
          if(!ethereum) return ('Please Install Metamask')

          const transactionsContract = getEthereumContract();
          const availableTransactions=await transactionsContract.getAllTransactions();

          const structuredTransactions=availableTransactions.map((x)=>({
            addressTo:x.receiver,
            addressFrom:x.sender,
            timestamp:new Date(x.timestamp.toNumber()*100).toLocaleString(),
            message:x.message,
            keyword:x.keyword,
            amount:parseInt(x.amount._hex)/(10**18)

          }))
          console.log('...',structuredTransactions);
          setTransactions(structuredTransactions);

      } catch (error) {
        console.log(error);
      }
  }
  const checkIfWalletIsConnected = async () => {
    try {
      if (!ethereum) return alert("Please Install Metamask");

      const accounts = await ethereum.request({ method: "eth_accounts" });

      if (accounts.length) {
        setCurrentAccount(accounts[0]);
        getAllTransactions();
      } else {
        console.log("No Accounts Found");
      }
      console.log(accounts);
    } catch (error) {
      console.log(error);
      throw new Error("No Ethereum Object");
    }
  };

  const checkIfTransactionExist=async ()=>{
      try {
        const transactionsContract = getEthereumContract();
        const transactionsCount = await transactionsContract.getTransactionCount();
        window.localStorage.setItem('transaction count',transactionsCount)
      } catch (error) {
        console.log(error);
        throw new Error("No Ethereum Object");
      }
  }

  useEffect(() => {
    checkIfWalletIsConnected();
    checkIfTransactionExist();
  }, []);

  const connectWallet = async () => {
    try {
      if (!ethereum) return alert("Please Install Metamask");

      const accounts = await ethereum.request({
        method: "eth_requestAccounts",
      });

      setCurrentAccount(accounts[0]);
    } catch (error) {
        console.log(error)
        throw new Error("No Ethereum Object");
    }
  };

  const sendTransactions=async()=>{
    try {
        if (ethereum) {
          const { addressTo, amount, keyword, message } = formData;
          const transactionsContract = getEthereumContract();
          const parsedAmount = ethers.utils.parseEther(amount);
  
          await ethereum.request({
            method: "eth_sendTransaction",
            params: [{
              from: currentAccount,
              to: addressTo,
              gas: "0x5208",
              value: parsedAmount._hex,
            }],
          });
  
          const transactionHash = await transactionsContract.addToBlockchain(addressTo, parsedAmount, message, keyword);
  
          setIsLoading(true);
          console.log(`Loading - ${transactionHash.hash}`);
          await transactionHash.wait();
          console.log(`Success - ${transactionHash.hash}`);
          setIsLoading(false);
  
          const transactionsCount = await transactionsContract.getTransactionCount();
  
          setTransactionCount(transactionsCount.toNumber());
          window.location.reload();
        } else {
          console.log("No ethereum object");
        }
      } catch (error) {
        console.log(error);
  
        throw new Error("No ethereum object");
      }
  }

  return (
    <TransactionContext.Provider value={{ connectWallet,isLoading,transactions,currentAccount,formData,setFormData,handleChanges,sendTransactions }}>
      {children}
    </TransactionContext.Provider>
  );
};
